import { render, staticRenderFns } from "./HmiLabel.vue?vue&type=template&id=0c7b804e&scoped=true"
import script from "./HmiLabel.vue?vue&type=script&lang=js"
export * from "./HmiLabel.vue?vue&type=script&lang=js"
import style0 from "./HmiLabel.vue?vue&type=style&index=0&id=0c7b804e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b804e",
  null
  
)

export default component.exports